<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M9 6.5a2.5 2.5 0 1 0-1.17 2.12 8.8 8.8 0 0 1-.96 2.76 12.06 12.06 0 0 1-2.22 2.77.5.5 0 0 0 .7.7h.02c.74-.75 1.66-1.67 2.38-2.98A10.83 10.83 0 0 0 9 6.5Zm5.83 2.12A2.5 2.5 0 1 1 16 6.5c0 2.33-.52 4.04-1.25 5.37-.72 1.3-1.64 2.23-2.38 2.97l-.02.01a.5.5 0 0 1-.7-.7c.75-.76 1.57-1.59 2.22-2.77a8.8 8.8 0 0 0 .96-2.76Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M7.83 8.62a8.8 8.8 0 0 1-.96 2.76 12.06 12.06 0 0 1-2.22 2.77.5.5 0 0 0 .7.7h.02c.74-.75 1.66-1.67 2.38-2.98A10.83 10.83 0 0 0 9 6.5a2.5 2.5 0 1 0-1.17 2.12ZM8 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.83 2.12a8.8 8.8 0 0 1-.96 2.76 12.06 12.06 0 0 1-2.22 2.77.5.5 0 0 0 .7.7h.02c.74-.75 1.66-1.67 2.38-2.98A10.83 10.83 0 0 0 16 6.5a2.5 2.5 0 1 0-1.17 2.12ZM13.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
    />
  </svg>
</template>
